/** A device drawn as itself on a device card (component library, lib-13): a till, a wall screen or a printer, its
 * screen ink when running, grey when offline, empty while it waits to pair. Styles: .o-devpic in portal.css. */
export function DevicePic({ kind, state = "on", icon }: { kind: "till" | "wall" | "printer" | "tablet"; state?: "on" | "offline" | "unpaired"; icon: string }) {
  return (
    <span className={`o-devpic o-devpic--${kind}${state === "on" ? "" : ` is-${state}`}`} aria-hidden="true">
      <span className="o-devpic__scr">
        <span className="ms">{icon}</span>
      </span>
    </span>
  );
}
